module.exports = __webpack_public_path__ + "media/reskin-images/img--study-groups-03fd1c5c.png";